export enum THEMES {
    DEFAULT = 'default',
    NARROW = 'narrow',
}
